export default "__VITE_ASSET__6a651346__"